import graphql__5e35e65f641e83fd46b9 from "./__generated__/ReportMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__5e35e65f641e83fd46b9;

function report(reportableId, onCompleted) {
  const variables = { reportableId };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { report };
